module.exports = __webpack_public_path__ + "img/11.13546d60.jpg";